export default __webpack_public_path__ + "static/media/footer-logo.31f83c77.svg";